import { Type } from '@sinclair/typebox';
import { BaseTxSchema } from './base-tx.js';
export const LpBurnFields = {
    operation: Type.Literal('lpBurn'),
};
export const LpBurnTxSchema = Type.Object({
    ...BaseTxSchema.properties,
    ...LpBurnFields,
});
//# sourceMappingURL=lp-burn-tx.js.map